<template>
  <div class="search">
  <div >
    <s-header :name="$t('header.searchsearch')"></s-header>
  </div>
  <div class="header-search">
    <a @click="searchproduct"><i class="nbicon nbSearch"></i></a>
          <input
            type="text"
            class="search-title"
            v-model="keyword"
            :placeholder="$t('header.search')"/>
            <!-- <router-link v-if="$i18n.locale == 'en'" tag="span" class="search-title" to="./search?from=home&ishide=1">please enter product key word</router-link>
          <router-link v-else  tag="span" class="search-title" to="./search?from=home&ishide=1">请输入产品关键字</router-link>  --> 
        </div>
        <header v-if=" this.searhis.size>0" class="good-header">历史搜索</header>
  </div>
</template>

<script>
import fetch from "@/js/axios";
import { Toast } from 'vant'
import sHeader from '@/components/SimpleHeader'
export default {
  name: 'search',
  data() {
    return {
      keyword: '',
      searhis:[]
    }
  },
  components: {
    sHeader
  },
  async mounted() {
    if(localStorage.getItem("searhis"))
    {
      this.searhis=JSON.parse(localStorage.getItem("searhis"))
    }
  },
  methods:{
    searchproduct(){
      if(this.keyword){
       this.searhis.push(this.keyword)
        localStorage.setItem("searhis", JSON.stringify(this.searhis));
        this.$router.push({path:'/product?keyword='+this.keyword})
      }
    }
  }
}
</script>

<style lang="less" scoped >
  @import '../style/mixin';
  .header-search {
          display: flex;
          .wh(90%, 20px);
          line-height: 20px;
          margin: 10px 3%;
          padding: 5px 10px;
          color: #232326;
          background: rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          justify-content: space-between;
          .app-name {
              padding: 0 10px;
              color: @primary;
              font-size: 20px;
              font-weight: bold;
              border-right: 1px solid #666;
          }
          .icon-search {
              padding: 0 10px;
              font-size: 17px;
          }
          .search-title {
              font-size: 14px;
              color: #666;
              line-height: 21px;
              padding-left: 10px;
              background:transparent
          }
          input{
            width: 90%;
          }
      }
      
    .good-header {
      background: #f9f9f9;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: @primary;
      font-size: 16px;
      font-weight: 500;
    }
</style>



// WEBPACK FOOTER //
// src/views/Search.vue